import Vue from 'vue';

export const state = {
  data: {},
};
export const actions = {
  setActionStatus({ commit }, { actionPath, statusType, status }) {
    commit('setActionStatus', { actionPath, statusType, status });
  },
  setActionError({ commit }, { actionPath, status }) {
    commit('setActionStatus', { actionPath, statusType: 'error', status });
  },
  setActionLoading({ commit }, { actionPath, status }) {
    commit('setActionStatus', { actionPath, statusType: 'loading', status });
  },
};
export const mutations = {
  setActionStatus(state, { actionPath, statusType, status }) {
    Vue.set(state.data, actionPath, { [statusType]: status });
  },
};
export const getters = {
  getActionStatus: state => ({ actionPath, statusType }) => {
    const found = state.data.hasOwnProperty(actionPath);
    return found ? state.data[actionPath][statusType] : null;
  },
  getActionErrorStatus: state => actionPath => {
    const stateData = JSON.parse(JSON.stringify(state.data));
    const found = stateData.hasOwnProperty(actionPath);
    return found ? stateData[actionPath]['error'] : null;
  },
};
